import React from 'react';
import { map, isEmpty, size, head, get, last } from 'lodash';
import moment from 'moment';
import classnames from 'classnames';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { withNetworkState } from 'ui/hoc/withNetworkState';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { actionWidgetActivity as ActionWidgetActivity } from 'ui/views/widgets/actionWidgetActivity';
 *
 * // render
 * <ActionWidgetActivity propName='propValue'/>
 */
export const actionWidgetActivitySuccess = ( props ) => {

    const { widget, items } = props;

    // dashed line class name
    const dashbedLineClassName = classnames( 'ui-action-widget-activity__items-pane__dashed-line', {
        'ui-action-widget-activity__items-pane__dashed-line--hidden': 2 > size( items ), // hide it when `items` are less than 2
        [ `ui-action-widget-activity__items-pane__dashed-line--top-offset-${ size( get( head( props.items ), 'values' ) ) }` ]: ! isEmpty( get( head( props.items ), 'values' ) ), // large offset from `top` if `subtitle` of the `first` item is present
        [ `ui-action-widget-activity__items-pane__dashed-line--bottom-offset-${ size( get( last( props.items ), 'values' ) ) }` ]: ! isEmpty( get( last( props.items ), 'values' ) ), // large offset from `bottom` if `subtitle` of the `last` item is present
    } );

    return (
        <div className='ui-action-widget-activity'>
             <p className='ui-action-widget-activity__title'>
            { getLabel( widget.title ) }
        </p>
            <div className='ui-action-widget-activity__items-pane'>

            <div className='ui-action-widget-activity__items-pane__group'>
                
                {/* dashed line */}
                <div className={ dashbedLineClassName }></div>

                {/* items */}
                <div className='ui-action-widget-activity__items-pane__items'>
                    {
                        map( items, item => {

                            // dynamic item class name
                            const itemClassName = classnames( 'ui-action-widget-activity__items-pane__items__item', {
                                [ `ui-action-widget-activity__items-pane__items__item--height-${ size( item.values ) }` ]: ! isEmpty( item.values ),
                            } );

                            return (
                                <div key={ item.id } className={ itemClassName }>
                                    {/* title */}
                                    <p className='ui-action-widget-activity__items-pane__items__item__title'>{ item.title }</p>

                                    {/* values */}
                                    {
                                        map( item.values, ( _value, _index ) => {
                                            return (
                                                <p key={ _index } className='ui-action-widget-activity__items-pane__items__item__title'>{ _value }</p>
                                            );
                                        } )
                                    }

                                    {/* timestamp */}
                                    <p className='ui-action-widget-activity__items-pane__items__item__timestamp'>{ moment( item.timestamp ).format( 'MM-DD-YYYY hh:mm:ss A' ) }</p>
                                </div>
                            );
                        } )
                    }
                    </div>
                </div>
            </div>
        </div>
    );
};

// set display name
actionWidgetActivitySuccess.displayName = 'actionWidgetActivitySuccess';

// set default props
actionWidgetActivitySuccess.defaultProps = {};

// prop types
actionWidgetActivitySuccess.propTypes = {};

// preloader view
export const actionWidgetActivityPreloader = () => {
    return (
        <div className='ui-action-widget-activity-preloader'>
            <div className='ui-action-widget-activity-preloader__title'/>
            {
                    map( [ 1, 2, 3, 4, 5, 6, 7 ], item => {
                        return (
                            <div key={ item } className='ui-action-widget-activity-preloader__item'>
                                <div className='ui-action-widget-activity-preloader__item__title'/>
                                <div className='ui-action-widget-activity-preloader__item__subtitle'/>
                            </div>
                        );
                    } )
                }
        </div>
    );
};

// set display name
actionWidgetActivityPreloader.displayName = 'actionWidgetActivityPreloader';

// set default props
actionWidgetActivityPreloader.defaultProps = {};

// prop types
actionWidgetActivityPreloader.propTypes = {};

export const actionWidgetActivity = withNetworkState( actionWidgetActivityPreloader, actionWidgetActivitySuccess );

